import styled from 'styled-components';

export const Title = styled.div`
	display: flex;
	align-items: center;
	/* in order for ellipsis to work */
	min-width: 0;
`;
